import { Button, Modal } from "antd";
import "./CreateFolderModal.scss";

export interface DesignInPrintProductionModalProps {
  isVisible: boolean;
  onClose: () => void;
  open: () => void;
}

export function DesignInPrintProductionModal({isVisible, onClose, open}: DesignInPrintProductionModalProps) {
  return (
    <Modal
      className={"create-folder-modal clean"}
      visible={isVisible}
      onCancel={() => onClose()}
    >
      <header>
        <h2>Warning</h2>
      </header>

      <p>
        This design is in print production.<br/>
        Any changes made will NOT be included on the printed version.
      </p>

      <footer>
        <Button size={"large"} onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={open}>
          Continue To Editor
        </Button>
      </footer>
    </Modal>
  );
}
